import { createSelector } from 'reselect'
import _ from 'lodash';

export const projectsList = (state) => state.projects.projects;
export const projectsLoading = (state) => state.projects.projectsLoading;
export const projectsLoadedTenant = (state) => state.projects.projectsLoadedTenant;



// WEBPACK FOOTER //
// ./src/storeState/projects/selectors.js